import ContainerPages from 'containers/ContainerPages'
import React from 'react'
import Privacy from '../../components/privacy/index'

export default function Container() {
  return <Privacy />
}
